<script lang="ts">
  import { createDropdownMenu, melt } from "@melt-ui/svelte";

  const {
    elements: { separator },
  } = createDropdownMenu();
</script>

<div class="-mx-4 h-px w-[calc(100%+2rem)] bg-white/10 dark:bg-black/5" {...$separator} use:$separator.action></div>
